import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
    updateSettingsDrop
} from '../../../actions/settings';
import { Table } from './Table';
import { faqs } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';


let Faqs = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            faqToEdit: null,
            faqToAdd: null,
            orderCollection:[],
        }

        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addFaq = this._addFaq.bind(this);
        this._updateFaq = this._updateFaq.bind(this);
        this.updateFaqDrop = this.updateFaqDrop.bind(this);
        

    }

    componentDidMount() {
        this._load();
    }

    _load() {
        this.props.getSettings(faqs);
    }

    _onAddClick() {
        this.props.clearUpdateSettings(faqs);
        let faq = { Order : this.orderCollection.length + 1};
        this.setState({faqToAdd: faq , showAddModal: true});
    }

    _addFaq(faq) {
        this.props.updateSettings(faqs, faq);
    }

    _onClose() {
        this.setState({
            showAddModal: false,
            faqToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(faqs);
    }

    _onEditClick(faq) {
        this.props.clearUpdateSettings(faqs);
        this.setState({ faqToEdit: faq, showUpdateModal: true })
       
    }

    _updateFaq(faq) {
        
        this.props.updateSettings(faqs, faq, faq.Id);
    }

    updateFaqDrop(faq) {
        this.props.updateSettingsDrop(faqs, faq, faq.Id);
    }

    render() {
        const { faqs: { data, fetching } } = this.props;
        const { showAddModal, showUpdateModal, faqToEdit, faqToAdd } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: faqToEdit ? faqToEdit : faqToAdd,
            listData:data,
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addFaq : this._updateFaq
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        this.orderCollection = data;
        return (
            <Panel>
                <Panel.Heading >
                    <span>Вопрос Ответ</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body >

                    <Table
                        fetching={fetching}
                        faqs={data}
                        onEdit={this._onEditClick}
                        isReadOnly={isReadOnly} 
                        updateFaqDrop = {this.updateFaqDrop}
                        />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                </Panel.Body>
            </Panel>
        );
    }
}

Faqs = connect(state => {
    return { faqs: state.application.get('settings')[faqs] };
}, { getSettings, updateSettings, clearUpdateSettings ,updateSettingsDrop})(Faqs);


export default Faqs;


// WEBPACK FOOTER //
// ./src/components/settings/faq/Faq.jsx